import React from "react";
import Headings from "../../constants/headings";
function LockPage(props) {
  return (
    <main>
      <div className="top-margin"></div>
      <div className="main-container user-info-container">
        <h1 className="validation-error text-center mt-5 pt-5">
          {Headings.NotValidBrowser}
        </h1>
      </div>
    </main>
  );
}
export default LockPage;
